<template>
  <div class="page-menu" :class="{show: visible}">
    <div class="login-info">
      <div class="left-side">
        <div class="icon"></div>
        <span v-if="!isLogin" class="btn-login" @click="handleLogin">登录</span>
        <p class="user-info" v-else>
          <span>您好</span>
          <span class="name el">{{userName}}</span>
        </p>
      </div>
      <a v-if="isLogin" href="javascript:;" class="btn-logout" @click="logout">登出</a>
    </div>
    <template v-if="isLogin">
      <div v-if="!bindTicket || !bindTicket.bookingId" class="bind-box">
        <router-link tag="div" class="bind-ticket btn-common round" to="/bind_ticket">
          <img class="icon" src="../assets/icons/icon_ticket.png" alt="">
          <span>船票绑定</span>
        </router-link>
      </div>
      <div v-else class="bind-success">
        <div class="ticket">
          <div class="ticket-title">
            <span>船票订单号：{{bindTicket.bookingId}}</span>
            <router-link to="/bind_success" class="btn-detail">查看详情 ></router-link>
          </div>
          <div class="ticket-line"></div>
          <div class="ticket-info">
            <div>
              <div class="info-top">
                <span class="el">{{bindTicket.cruiseName}}</span>
                <span>{{bindTicket.sailDateBegin}}-{{bindTicket.sailDateEnd}}</span>
              </div>
              <div class="info-bottom">
                <span class="info-left name">{{bindTicket.pinyinLastName}} {{bindTicket.pinyinFirstName}}</span>
                <span class="info-info"><i>船名：</i>{{bindTicket.shipName}} <i>舱房号：</i>{{bindTicket.stateroomNumber}}</span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <van-collapse class="menus" v-model="activeNamesComuted">
      <van-collapse-item :name="item.name" v-for="(item, i) in menus" :key="`menu${i}`" :is-link="!!item.children">
        <div class="menu-title" slot="title" @click="menuClick(item.url)">
          <div class="title-info">
            <img class="icon" :src="require(`../assets/menu/icon${i+1}.png`)" alt="">
            <span>{{item.name}}</span>
          </div>
          <van-icon v-if="!item.children" class="arrow-right" name="arrow" />
        </div>
        <div v-if="item.children && item.children.length" class="sub-menu">
          <ul>
            <li class="sub-menu-item" v-for="(subMenu, j) in item.children" :key="`subMenu${i}${j}`" @click="menuClick(subMenu.url)">
              <div class="sub-menu-text">
                <div class="sub-menu-icon">
                  <img :src="require(`../assets/menu/sub_menu_${i+1}_${j+1}.png`)" alt="">
                </div>
                <p>{{subMenu.name}}</p>
              </div>
              <van-icon class="icon-arrow" name="play" />
            </li>
          </ul>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import { mapGetters, mapState } from 'vuex'
import { checkLoginStatus, toShoppingMall, gioTracking } from '@/plugins/common'

const menus = [
  {
    name: '活动预订',
    children: [
      {
        name: '超凡网络',
        url: '/Rccl.PCP/product/Wifi'
      }, {
        name: '超凡娱乐',
        url: '/Rccl.PCP/product/entertainment'
      }, {
        name: '超凡餐饮',
        url: '/Rccl.PCP/product/dining'
      }, {
        name: '超凡观光',
        url: '/Rccl.PCP/product/pcpShorex'
      }, {
        name: '超凡服务',
        url: '/Rccl.PCP/product/service'
      }
      // {
      //   name: '超凡购物',
      //   url: ''
      // }, {
      //   name: '超凡健康',
      //   url: ''
      // }
    ]
  }, {
    name: '行前订商城',
    url: 'home'
  }, {
    name: '我的订单',
    children: [
      {
        name: '活动订单',
        url: '/page_order_detail'
      },
      {
        name: '商城意向单',
        url: 'order'
      }
    ]
  }, {
    name: '用户指南',
    url: '/page_beginners_tips'
  }, {
    name: '常见问题',
    url: '/page_question'
  }, {
    name: '服务条款',
    url: '/terms'
  }, {
    name: '新闻中心',
    url: '/page_news_list'
  }
]
export default {
  name: 'PageMenu',

  props: {
    visible: Boolean
  },

  data () {
    return {
      menus,
      activeNames: []
    }
  },

  computed: {
    ...mapGetters(['isLogin']),
    ...mapState(['bindTicket', 'goodsCartNum', 'userName', 'isMiniApp']),
    activeNamesComuted: {
      get () {
        return this.activeNames
      },
      set (val) {
        const menuHasChildren = this.menus.filter(x => x.children && x.children.length).map(x => x.name)
        this.activeNames = val
        setTimeout(() => {
          this.activeNames = val.filter(x => menuHasChildren.indexOf(x) > -1)
        }, 150)
      }
    }
  },

  methods: {
    handleLogin () {
      if (this.isMiniApp) {
        window.wx.miniProgram.navigateTo({ url: '/pages/authorize/authorize' })
      } else {
        const campaignId=process.env.VUE_APP_API_KEY
        const viewSource='pcp'
        const origin=process.env.VUE_APP_LOGIN_URL
        const path=location.href
        console.log(path,'path')
        const currentHref=encodeURI(path)
        const loginURL=`${origin}/Orchard.Rccl.Users/Login/Login?returnUrl=${currentHref}&campaignId=${campaignId}&viewSource=${viewSource}`
        console.log('loginURL',loginURL)
        window.location.href=loginURL
      }
    },
    logout () {
      this.$store.commit('logout')
    },
    async menuClick (url) {
      if (!url) return
      if (url === '/page_order_detail') {
        await checkLoginStatus()
        showLoading('加载中...')
        const { errCode, errMsg } = await api.checkOrderStatus()
        hideLoading()
        if (errCode === 0) {
          // if (data.orderStatus === 1) {
          //   if (data.orderIsInChange) {
          //     await showAlert('您的购物车中有修改后未确认的产品，请先前往确认您的修改')
          //     this.$router.push(this.goodsCartNum ? '/page_shopping_cart' : '/')
          //   } else {
          //     this.$router.push(url)
          //   }
          // } else {
          //   showAlert('您还未提交订单，请选择产品后进入购物车结算')
          //   this.$router.push(this.goodsCartNum ? '/page_shopping_cart' : '/')
          // }
          this.$router.push(url)
        } else {
          showAlert(errMsg || '检查失败，请稍后重试')
        }
      } else if (url === 'home' || url === 'order') {
        toShoppingMall(url)
      } else {
        this.$router.push(url)
      }
    },
    gioTrackingHandler (url) {

      switch (url) {
        case '/terms':
          gioTracking('track','evt_ButtonClicked',{'btnType':'SA'}); break;
        case '/page_news_list':
          gioTracking('track','evt_ButtonClicked',{'btnType':'News'}); break;
        case '/page_question':
          gioTracking('track','evt_ButtonClicked',{'btnType':'FAQ'}); break;
        case '/page_beginners_tips':
          gioTracking('track','evt_ButtonClicked',{'btnType':'userManuel'}); break;
        default: break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-menu {
  position: fixed;
  top: 122px;
  left: 0;
  z-index: 99;
  width: 0;
  height: 0;
  box-sizing: border-box;
  padding-bottom: 32px;
  border-radius: 50%;
  border-top-left-radius: 0;
  background-color: #fff;
  overflow: hidden;
  transition: all .3s;
  &.show {
    width: 100%;
    height: calc(100vh - 228px);
    border-radius: 0;
    overflow-y: auto;
  }
}
.login-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 230px;
  padding: 0 46px;
  background-color: #fff;
  .left-side {
    display: flex;
    align-items: center;
    font-size: 46px;
    color: #1174b8;
    .icon {
      flex: none;
      width: 120px;
      height: 120px;
      border-radius: 50%;
      background: #caccda url("../assets/logo_small.png") center center no-repeat;
      background-size: 49px auto;
    }
    .btn-login {
      margin-left: 46px;
    }
    .user-info {
      display: flex;
      align-items: baseline;
      margin-left: 26px;
      font-size: 36px;
      color: #999;
      .name {
        max-width: 300px;
        margin-left: 12px;
        font-size: 48px;
        color: #333;
      }
    }
  }
  .btn-logout {
    padding: 0 6px 0 44px;
    font-size: 30px;
    color: #017aff;
    background: url("../assets/icons/icon_logout.png") 0 center no-repeat;
    background-size: 27px auto;
  }
}
.bind-box {
  padding: 16px 0;
  .icon {
    flex: none;
    width: 29px;
    margin-right: 14px;
  }
}
.bind-success {
  padding: 25px 46px 32px;
  background-image: linear-gradient(to right, #ffdb17 , #fcbf00);
  .ticket {
    border-radius: 8px;
    background-color: #fff;
    .ticket-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 52px;
      padding: 7px 28px 0;
      box-sizing: border-box;
      font-size: 24px;
      color: #999;
      .btn-detail {
        color: #1174b8;
      }
    }
    .ticket-line {
      height: 11px;
      background: url("../assets/ticket_line.png") 0 0 no-repeat;
      background-size: 100% 100%;
    }
    .ticket-info {
      display: flex;
      align-items: center;
      height: 110px;
      padding: 0 30px;
      font-size: 24px;
      color: #000;
      line-height: 36px;
      .info-top {
        display: flex;
        align-items: center;
        span {
          margin-right: 0px;
          &:first-child {
            flex: none;
            max-width: 260px;
            margin-right: 40px;
          }
        }
      }
      .info-bottom {
        line-height: 42px;
      }
      .name {
        font-size: 24px;
        font-weight: bold;
        max-width: 160px;
        overflow: hidden;
      }
      .info-info {
        font-weight: bold;
        i {
          margin-left: 36px;
          font-style: normal;
          font-weight: normal;
          color: #999;
        }
      }
    }
  }
}
.menus {
  ::v-deep .van-cell {
    height: .9rem;
    transition: all .3s;
    &.van-collapse-item__title--expanded {
      background-color: #eaeaea;
      .van-icon {
        color: #1174b8;
      }
    }
  }
  ::v-deep .van-cell:not(:last-child)::after {
    left: 0;
    border-bottom: 1px solid #eaeaea;
  }
  ::v-deep .van-cell__right-icon {
    color: #d9dde6;
    transition: all .3s;
  }
  ::v-deep .van-collapse-item__content {
    padding: 0;
  }
  .menu-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 30px;
    color: #646566;
    .title-info {
      display: flex;
      align-items: center;
      .icon {
        width: 33px;
        margin-right: 16px;
      }
    }
    .arrow-right {
      color: #d9dde6;
    }
  }
  .sub-menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 82px;
    padding: 0 46px 0 106px;
    border-bottom: 1px solid #eaeaea;
    &:last-child {
      border: none;
    }
    &:active {
      background-color: #eee;
    }
    .sub-menu-text {
      display: flex;
      align-items: center;
      font-size: 30px;
      color: #646566;
      .sub-menu-icon {
        flex: none;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 42px;
        height: 42px;
        margin-right: 16px;
        border-radius: 50%;
        background-color: #1174b8;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
    .icon-arrow {
      font-size: 12px;
      color: #cdcccc;
    }
  }
}
</style>
